import { Product } from '@portal/portal-core';
import * as utils from '../utils';

const { NAMES_UI_TABS } = Product;

// Contact email addresses
export const CONTACT_EMAILS = {
  DEFAULT: 'flowjooffice@bd.com',
  CHINA: 'FlowJoChina@bd.com',
  CYTOGNOS: 'support.cytognos@bd.com',
};

// Product-specific contact email mapping
const PRODUCT_CONTACT_EMAIL_MAP: Record<string, string> = {
  [NAMES_UI_TABS.flowJo]: CONTACT_EMAILS.DEFAULT,
  [NAMES_UI_TABS.seqGeq]: CONTACT_EMAILS.DEFAULT,
  [NAMES_UI_TABS.bdrc]: CONTACT_EMAILS.DEFAULT,
  [NAMES_UI_TABS.facsWorkflowManager]: CONTACT_EMAILS.DEFAULT,
  [NAMES_UI_TABS.infinicytRuo]: CONTACT_EMAILS.CYTOGNOS,
  [NAMES_UI_TABS.infinicytIvd]: CONTACT_EMAILS.CYTOGNOS,
  [NAMES_UI_TABS.infinicytEa]: CONTACT_EMAILS.CYTOGNOS,
  [NAMES_UI_TABS.infinicytIuo]: CONTACT_EMAILS.CYTOGNOS,
};

/** Get the contact email address for a given product (China region takes precedence). */
export const getContactEmail = (productName: string): string => {
  // China region takes precedence over all other settings
  if (utils.chinaFlag()) {
    return CONTACT_EMAILS.CHINA;
  }

  // Return product-specific email or default
  return PRODUCT_CONTACT_EMAIL_MAP[productName] || CONTACT_EMAILS.DEFAULT;
};
